module.exports = __webpack_public_path__ + "img/pre_icon.50c6df2.png";